
// import './App.css';
import CareerType from './CareerType';
import ResidenceTiers from './ResidenceTiers';
import './dataviz.scss'
import RetirementYears from './RetirementYears';
import CareerTrend from './CareerTrend';
import GenderLongevityV2 from './GenderLongevityV2';
import Methodology from './Methodology';



function App() {

  return (
    <div className='App'>
    
    <div style={{ 
      height: '140vh' ,
      backgroundColor:'#F6F2EF', 
      position:'relative',
      }}>
        {/* 中国奥运冠军今何在 */}
      <img 
      src={`${process.env.PUBLIC_URL + '/images/chinese-olympic-golds_cover.jpg'}`} 
      alt={`因金牌而改变一生 中国奥运冠军今何在？`}
      style={{
        height:'98vh',
        width:'100%',
        objectFit:'cover',
        objectPosition: '7% 10%',
        position:'sticky',
        top:'0',
        zIndex:'0',
        transform: 'translate3d(0, 0, 0)'
      }}
      />
      <div style={{height:'2vh'}}></div>
      <div className='heading'>
        <div>
          <span>数据报道</span>
          <h1>因金牌而改变一生<br/>&nbsp;中国奥运冠军今何在？</h1>
          <p>08/12/2024</p>
          </div>
        </div>
      
      </div>
      
    

    <div className='content'>
      <div className='content__text intro'>
      <p>在刚刚过去的巴黎奥运会上，中国代表团以40块金牌的成绩，与美国并列排名世界第一。1984夏季洛杉矶奥运会，中国首次实现了奥运史上金牌“零”的突破。仅仅用了40年，中国就从“零金牌”飞跃至“金牌大国”。</p>
      <p>从1984年许海峰在射击比赛中为中国摘得首金，到2024年李雯雯在女子举重比赛中获得最近一块金牌，中国共产生了319位奥运冠军。毫无疑问的是，奥运冠军的努力改变了中国在奥运赛事中的形象，但奥运金牌本身，到底是否改变了他们个体的人生呢？不同竞技项目的冠军，都被赋予等价的变现方式吗？运动生涯终究是短暂的，退役后的他们，如何开启自己的第二人生呢？国人赋予奥运赛事的期待，又如何影响了中国奥运冠军的运动生涯呢。</p>
      <p>歪脑整理了从1984年至今，在中国大陆出生长大的319位奥运冠军的公开资料。根据他们的出生地、现居地、竞技项目、职业发展等数据，我们可以一窥在举国体制模式下，中国奥运冠军的第二人生版图。歪脑与你分享我们的发现。读者点击图表内容，可查看详细信息。</p>
      </div>

      <div className='intro-image'>
          <img src={`${process.env.PUBLIC_URL + '/images/closing.jpeg'}`}
          alt={`2024年8月11日，巴黎奥运闭幕式，中国队走入体育场。`} />
          <div className='scroll__caption'>2024年8月11日，巴黎奥运闭幕式，中国队走入体育场。(AP / Martin Meissner)</div>
      </div>

    </div>

    <CareerType />
    <CareerTrend />
    <ResidenceTiers/> 
    <GenderLongevityV2 /> 
    <RetirementYears />
    <Methodology /> 

    </div>
    );
}

export default App;
